import React from 'react'

import "./OverlayBtn.css";

function OverlayBtn({icon}) {
    return (
        <div className='btnOverlay'>
            {icon}
        </div>
    )
}

export default OverlayBtn

